import Main from "./pages/Main";
import "animate.css";
import "react-image-lightbox/style.css";
import ModeToggle from "./components/utils/ModeToggle";
import { useState } from "react";
import { TEMPLATE_OPTIONS } from "./data/data";

export default function App() {
	const [dark, setDark] = useState(TEMPLATE_OPTIONS.theme === "dark");

	return (
		<div className={dark && "dark"}>
			<Main />
			{TEMPLATE_OPTIONS.showThemeToggle && (
				<ModeToggle dark={dark} setDark={setDark} />
			)}
		</div>
	);
}
